import { captureException as sentryCaptureException } from "./sentry-lazy";

const isProd = import.meta.env.PROD;

type LogArgs = unknown[];

export interface Logger {
  log: (...args: LogArgs) => void;
  debug: (...args: LogArgs) => void;
  info: (...args: LogArgs) => void;
  warn: (...args: LogArgs) => void;
  error: (...args: LogArgs) => void;
}

function forwardErrorToSentry(namespace: string, args: LogArgs) {
  if (args.length === 0) return;
  const [first, ...rest] = args;
  const extra: Record<string, unknown> = { namespace, args: rest };
  if (first instanceof Error) {
    sentryCaptureException(first, extra);
  } else {
    sentryCaptureException(new Error(String(first)), extra);
  }
}

export function createLogger(namespace: string): Logger {
  const tag = `[${namespace}]`;
  return {
    log: isProd ? () => {} : (...args) => console.log(tag, ...args),
    debug: isProd ? () => {} : (...args) => console.debug(tag, ...args),
    info: isProd ? () => {} : (...args) => console.info(tag, ...args),
    warn: (...args) => console.warn(tag, ...args),
    error: (...args) => {
      console.error(tag, ...args);
      forwardErrorToSentry(namespace, args);
    },
  };
}

export const logger = createLogger("thnx");
